import { useLayoutEffect, useRef, useState } from "react"
import { motion } from "framer-motion"

const InfiniteScrollSentence = ({ sentence }) => {

    const containerRef = useRef(null)
    const textRef = useRef(null)

    const [shouldScroll, setShouldScroll] = useState(false)

    useLayoutEffect(() => {
        const checkOverflow = () => {
            if (containerRef.current && textRef.current) {
                const containerWidth = containerRef.current.offsetWidth
                const textWidth = textRef.current.scrollWidth

                const overflowAmount = textWidth - containerWidth
                if (overflowAmount > 0) {
                    setShouldScroll(true)
                } else {
                    setShouldScroll(false)
                }
            }
        }

        checkOverflow()

        // Optional: Re-check on resize
        window.addEventListener("resize", checkOverflow)
        return () => window.removeEventListener("resize", checkOverflow)
    }, [sentence])

    return (
        <div
            ref={containerRef}
            className="text-white overflow-hidden whitespace-nowrap relative"
            style={{ height: "15px" }}
        >
            {shouldScroll ? (
                <motion.div
                    className="absolute flex"
                    initial={{ x: "100%" }} // Start off-screen to the right (100%)
                    animate={{ x: "-100%" }} // Scroll to the left (100% of container width)
                    transition={{
                        repeat: Infinity,
                        repeatType: "loop",
                        ease: "linear",
                        duration: 10, // Adjust speed of scroll here (larger = slower)
                    }}
                >
                    <span ref={textRef} className="mr-10">{sentence}</span>
                </motion.div>
            ) : (
                <div ref={textRef} className="text-center w-full">
                    {sentence}
                </div>
            )}
        </div>
    )
}

export default InfiniteScrollSentence
